import React from 'react';

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      data-testid='icon_arrow-down'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
    >
      <path fill='none' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M12 5v14' />
      <path fill='none' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M19 12l-7 7-7-7' />
    </svg>
  );
}

export default Icon;
